// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain as saveOrderChain } from "@insite/client-framework/Store/Pages/Cart/Handlers/SaveOrder";
import { chain as placeOrderChain } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import {
    chain as PlaceOrderForApprovalChain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrderForApproval";
import setNotes from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetNotes";
import resetXCheckoutState from "@werner/App/Handlers/Checkout/ResetLocalState";

export const DispatchCheckoutDataCleanup: any = (props: any) => {
    props.dispatch(setNotes({ notes: "" }));
    props.dispatch(resetXCheckoutState());
};

export const DispatchCartDataCleanup: any = (props: any) => {
    props.dispatch(resetXCheckoutState());
};

addToEndOfChain(placeOrderChain, DispatchCheckoutDataCleanup);
addToEndOfChain(PlaceOrderForApprovalChain, DispatchCheckoutDataCleanup);
addToEndOfChain(saveOrderChain, DispatchCartDataCleanup);
